/**
 * Add-or-remove on an immutable Set, returning a new one.
 *
 * Nine call sites had written this loop out by hand — the board's people filter and fleet
 * bands, the People page's crew and job filters, User Management's row selection and role
 * filter, the audit log's two filters, the register's folded groups, the day time-off dialog's
 * picks. Every one was the same five lines, and one of them was already written the other way
 * round. A filter that toggles wrong is a filter that quietly shows the wrong people.
 */
export function toggleInSet(set, value) {
  const next = new Set(set)
  if (next.has(value)) next.delete(value)
  else next.add(value)
  return next
}

/**
 * A multi-select filter as one URL parameter: comma-joined, and absent when empty — the shape
 * the design rules ask for (`?type=invoice,receipt`, never `type[]=`). Shared by the board's
 * and the People page's URL state so the two cannot disagree about how a list is spelled.
 */
export const toCsv = (values) => {
  const list = [...values]
  return list.length ? list.join(',') : null
}

export const fromCsv = (s) => (s ? s.split(',').filter(Boolean) : [])
